export default [
  // Authenticated routes.
  ...middleware('auth', [
    {path: '/', name: 'home', component: require('~/pages/home').default},
    {
      path: '/settings', component: require('~/pages/settings/index').default,
      children: [
        {path: '', redirect: {name: 'settings.profile'}},
        {path: 'profile', name: 'settings.profile', component: require('~/pages/settings/profile').default},
        {path: 'password', name: 'settings.password', component: require('~/pages/settings/password').default}
      ]
    },
    {
      path: '/system', component: require('~/pages/system/index').default,
      children: [
        {path: 'users', name: 'system.user_list', component: require('~/pages/system/UserList').default},
        {path: 'users/:id', name: 'system.user_detail', component: require('~/pages/system/UserDetail').default},
        {path: 'approvers', name: 'system.approvers_list', component: require('~/pages/system/ApproversList').default},
        {path: 'approvers/:id', name: 'system.approvers_detail', component: require('~/pages/system/ApproversDetail').default},
        {path: 'roles', name: 'system.role_list', component: require('~/pages/system/RoleList').default},
        {path: 'roles/:id', name: 'system.role_detail', component: require('~/pages/system/RoleDetail').default},
        {path: 'permissions', name: 'system.permission_list', component: require('~/pages/system/PermissionList').default},
        {path: 'permissions/:id', name: 'system.permission_detail', component: require('~/pages/system/PermissionDetail').default},
        {path: 'translations', name: 'system.translation_list', component: require('~/pages/system/TranslationList').default},
        {path: 'ipaddresses', name: 'system.ipaddress_list', component: require('~/pages/system/IpAddressList').default},
        {path: 'ipaddresses/:id', name: 'system.ipaddress_detail', component: require('~/pages/system/IpAddressDetail').default},
        {path: 'audit_log', name: 'system.audit_log', component: require('~/pages/system/ActivityLog').default},
        {path: 'data_changes', name: 'system.data_changes', component: require('~/pages/system/DataChange').default},
        {path: 'notifications', name: 'system.notification_list', component: require('~/pages/system/NotificationList').default},
        {path: 'apo_one_users', name: 'system.apo_one_user_list', component: require('~/pages/system/ApoOneUserList').default},
        {path: 'apo_one_users/:id', name: 'system.apo_one_user_detail', component: require('~/pages/system/ApoOneUserDetail').default},
        {path: 'apo_one_addresses', name: 'system.apo_one_address_list', component: require('~/pages/system/ApoOneAddressList').default},
        {path: 'apo_one_addresses/:id', name: 'system.apo_one_address_list_detail', component: require('~/pages/system/ApoOneAddressDetail').default},
        {path: 'regions', name: 'system.region_list', component: require('~/pages/system/RegionList').default},
        {path: 'regions/:id', name: 'system.region_detail', component: require('~/pages/system/RegionDetail').default},
        {path: 'report_access', name: 'system.report_access_list', component: require('~/pages/system/ReportAccessList').default},
        {path: 'report_access/:id', name: 'system.report_access_detail', component: require('~/pages/system/ReportAccessDetail').default},
        {path: 'template_files', name: 'system.template_file_list', component: require('~/pages/system/TemplateFileList').default},
        {path: 'template_files/:id', name: 'system.template_file_detail', component: require('~/pages/system/TemplateFileDetail').default},
      ]
    },
    {path: '/ticket/:ticket', name: 'ticket', component: require('~/pages/auth/ticket').default},
    {path: '/support', name: 'support', component: require('~/pages/support').default},
    // ...middleware('admin', [
    //   { path: '/admin', name: 'admin', component: require('~/pages/admin') }
    // ])
    // { path: '/example', name: 'example', component: require('~/pages/example'), middleware: ['admin'] },
  ]),

  // Guest routes.
  ...middleware('guest', [
    {path: '/login', name: 'login', component: require('~/pages/auth/login').default},
    {path: '/password/reset', name: 'password.request', component: require('~/pages/auth/password/email').default},
    {path: '/password/reset/:token', name: 'password.reset', component: require('~/pages/auth/password/reset').default},
    {path: '/two-factor-auth', name: 'two-factor-auth', component: require('~/pages/auth/TwoFactorAuth').default},
  ]),

  {path: '*', component: require('~/pages/errors/404.vue').default}
]

/**
 * @param  {String|Function} middleware
 * @param  {Array} routes
 * @return {Array}
 */
function middleware(middleware, routes) {
  routes.forEach(route =>
    (route.middleware || (route.middleware = [])).unshift(middleware)
  )

  return routes
}
